module.exports = __webpack_public_path__ + "img/I.9ac7514a.jpg";